import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './common/Header';
import Footer from './common/Footer';
import { Link } from 'react-router-dom';
import './blogs.css';

import { formatDateOnly } from '../utils/dateUtils';
const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [mostViewed, setMostViewed] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const blogsPerPage = 20;

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

    useEffect(() => {
        fetchBlogs();
        fetchMostViewed();
        window.scrollTo(0, 0);
    }, []);

    const fetchBlogs = async (search = '') => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}/blogs?search=${search}`);
            if (response.data.success) {
                setBlogs(response.data.data);
                setCurrentPage(1); // Reset to page 1 on new search
            }
        } catch (error) {
            console.error("Error fetching blogs:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchMostViewed = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/blogs/most-viewed`);
            if (response.data.success) {
                setMostViewed(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching most viewed blogs:", error);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        fetchBlogs(searchTerm);
    };

    const getBlogSlug = (title) => {
        if (!title) return '';
        return title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    };

    return (
        <div className="main-wrapper banner-content">
            <Header />
            <div className="blogs-page-container">
                <div className="container">
                    <div className="blogs-header">
                        <h1>Blogs</h1>

                    </div>

                    <div className="row">
                        {/* Left Side: Blog Listing */}
                        <div className="col-lg-8">
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-danger" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : blogs.length > 0 ? (
                                <>
                                {blogs.slice((currentPage - 1) * blogsPerPage, currentPage * blogsPerPage).map((blog) => (
                                    <div key={blog.id} className="blog-card">
                                        <div className="blog-image-wrapper">
                                            <img
                                                src={blog.image_url || 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'}
                                                alt={blog.blog_title}
                                            />
                                        </div>
                                        <div className="blog-content-wrapper">
                                            <div className="blog-meta">
                                                <span><i className="bi bi-calendar-event me-1"></i> {formatDateOnly(blog.created_at)}</span>
                                                <span><i className="bi bi-tag me-1"></i> {blog.category}</span>
                                            </div>
                                            <Link to={`/blog/${getBlogSlug(blog.blog_title)}`} className="blog-title">
                                                {blog.blog_title}
                                            </Link>
                                            <div className="blog-detail-content blog-excerpt" dangerouslySetInnerHTML={{ __html: blog.blog_desc }} />
                                            <Link to={`/blog/${getBlogSlug(blog.blog_title)}`} className="read-more-btn">
                                                Read More <i className="bi bi-arrow-right ms-1"></i>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                                
                                {/* Pagination Controls */}
                                {Math.ceil(blogs.length / blogsPerPage) > 1 && (
                                    <nav aria-label="Page navigation" className="mt-4 mb-5">
                                        <ul className="pagination justify-content-center">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                                                    Previous
                                                </button>
                                            </li>
                                            
                                            {[...Array(Math.ceil(blogs.length / blogsPerPage)).keys()].map(number => (
                                                <li key={number + 1} className={`page-item ${currentPage === number + 1 ? 'active' : ''}`}>
                                                    <button onClick={() => setCurrentPage(number + 1)} className="page-link">
                                                        {number + 1}
                                                    </button>
                                                </li>
                                            ))}

                                            <li className={`page-item ${currentPage === Math.ceil(blogs.length / blogsPerPage) ? 'disabled' : ''}`}>
                                                <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, Math.ceil(blogs.length / blogsPerPage)))}>
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                )}
                                </>
                            ) : (
                                <div className="alert alert-info border-0 shadow-sm">No blogs found. Try a different search term.</div>
                            )}
                        </div>

                        {/* Right Side: Sidebar */}
                        <div className="col-lg-4">
                            {/* Search Widget */}
                            <div className="sidebar-widget">
                                <h3 className="widget-title">Search Blogs</h3>
                                <form onSubmit={handleSearch} className="search-box">
                                    <input
                                        type="text"
                                        placeholder="Search blogs"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <button type="submit" className="search-btn">
                                        <i className="bi bi-search"></i>
                                    </button>
                                </form>
                            </div>

                            {/* Most Viewed Widget */}
                            <div className="sidebar-widget">
                                <h3 className="widget-title">Most Viewed Blogs</h3>
                                <div className="most-viewed-list">
                                    {mostViewed.length > 0 ? mostViewed.map((mv) => (
                                        <div key={mv.id} className="most-viewed-item">
                                            <div className="mv-thumb">
                                                <img
                                                    src={mv.image_url || 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=150&q=80'}
                                                    alt={mv.blog_title}
                                                />
                                            </div>
                                            <div className="mv-content">
                                                <Link to={`/blog/${getBlogSlug(mv.blog_title)}`} className="mv-title">
                                                    {mv.blog_title}
                                                </Link>
                                                <span className="mv-date">{formatDateOnly(mv.created_at)}</span>
                                            </div>
                                        </div>
                                    )) : <p className="text-muted small">No popular reports yet.</p>}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Blogs;
